// extracted by mini-css-extract-plugin
module.exports = {"result":"Result_result__bzLfj","resultList":"Result_resultList__3cNHC"};